import React, { PropsWithChildren, useState } from 'react';
import { style } from 'typestyle';
import { CheckBoxCustom } from './CheckBoxCustom';

interface Props {
  country: string;
  count: number;
  checked: boolean;
  negative: boolean;
  onChange: (checked: boolean) => void;
  isOpen?: boolean;
}

export function CountryCheckbox({ country, count, checked, negative, onChange, isOpen = false, children }: PropsWithChildren<Props>) {
  const [expanded, setExpanded] = useState(isOpen);

  const handleArrowClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setExpanded(!expanded);
  };

  const handleCheckboxChange = (newChecked: boolean) => {
    onChange(newChecked);
  };

  return (
    <div className={containerClass}>
      <div className={headerRowClass}>
        <span className={arrowClass} onClick={handleArrowClick}>
          {expanded ? '▼' : '▶'}
        </span>
        <CheckBoxCustom checked={checked} onChange={handleCheckboxChange} negative={negative}>
          <span>{country} ({count})</span>
        </CheckBoxCustom>
      </div>
      {expanded ? <div className={contentClass}>{children}</div> : null}
    </div>
  );
}

const containerClass = style({
  marginBottom: 4,
});

const headerRowClass = style({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
});

const arrowClass = style({
  fontSize: '10px',
  width: '12px',
  cursor: 'pointer',
  userSelect: 'none',
  flexShrink: 0,
});

const contentClass = style({
  marginLeft: '16px',
  marginTop: '4px',
});
